module.exports = __webpack_public_path__ + "img/7848761.jpg";